window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import {
    gsap
} from "gsap/dist/gsap";
import {
    ScrollTrigger
} from "gsap/dist/ScrollTrigger";
import {
    ScrollToPlugin
} from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
if (document.querySelector(".cta-footer")) {
    var footerAnimation = gsap.timeline({
        scrollTrigger: {
            trigger: ".cta-footer",
            start: "top 50%",
        },
        defaults: { // children inherit these defaults
            duration: 1,
            ease: "power2.out"
        },
    });
    footerAnimation
        .from(".animate-1", {
            scale: .6,
            xPercent: "50",
            duration: 1,
            opacity: 0
        }, "<.1");
    footerAnimation
        .from(".animate-2", {
            scale: .6,
            xPercent: "-50",
            duration: 1,
            opacity: 0
        }, "<.1");
    footerAnimation
        .from(".animate-3", {
            scale: .6,
            xPercent: "-50",
            duration: 1,
            opacity: 0
        }, "<.1")
}
if (document.querySelector("body.single-post")) {
    const postsMenu = document.getElementById('menu-item-1328');
    if (postsMenu) {
        postsMenu.classList.add('active');
    }
}
if (document.querySelector("body.single-orely-portfolio")) {
    const portfolioMenu = document.getElementById('menu-item-1327');
    if (portfolioMenu) {
        portfolioMenu.classList.add('active');
    }
}
let footerMenuTl = gsap.timeline({
    paused: false, // default is false
    defaults: { // children inherit these defaults
        ease: "power3.in"
    },
    smoothChildTiming: true,
    scrollTrigger: {
        trigger: ".footer-wrap",
        // markers: true,
        start: "top 90%",
    },
});
footerMenuTl.to(
    "#menu-secondary-menu li", {
        opacity: "1",
        y: "0px",
        stagger: 0.1
    }
)
var lastScrollTop; // This Varibale will store the top position
var navbar = document.getElementById('masthead'); // Get The NavBar
var scrollTop;;
window.addEventListener('scroll', function () {
    scrollTop = document.documentElement.scrollTop;
    if (scrollTop > 0) {
        navbar.classList.remove('nav-on-top');
        if (scrollTop > lastScrollTop) {
            if (navbar.classList.contains('nav-on-scoll-show')) {
                navbar.classList.remove('nav-on-scoll-show')
            };
            navbar.classList.add('nav-on-scoll-hide');
        } else {
            if (navbar.classList.contains('nav-on-scoll-hide')) {
                navbar.classList.remove('nav-on-scoll-hide')
            };
            navbar.classList.add('nav-on-scoll-show');
        }
    } else {
        navbar.classList.add('nav-on-top');
        if (navbar.classList.contains('nav-on-scoll-show')) {
            navbar.classList.remove('nav-on-scoll-show')
        };
        if (navbar.classList.contains('nav-on-scoll-hide')) {
            navbar.classList.remove('nav-on-scoll-hide')
        };
    }
    lastScrollTop = scrollTop
});
const faqItems = document.querySelectorAll('.faq');
if (faqItems) {
    faqItems.forEach(item => {
        const faqDesc = item.querySelector('.faq-desc');
        const angleIcon = item.querySelector('.arrow svg');
        const titleFAQASk = item.querySelectorAll('.itemClick')
        titleFAQASk.forEach(button =>{
            button.addEventListener('click', () => {
                item.classList.toggle('active');
                angleIcon.classList.toggle('active');
                faqDesc.classList.toggle('active');
            }); 
        })
       
    });
}
let timelineHamburger = gsap.timeline({
    paused: true, // default is false
    defaults: { // children inherit these defaults
        duration: .5,
    },
    smoothChildTiming: true,
});
timelineHamburger
    .fromTo('.mobile-menu .navbar.navbar-deafult ul li', {
        y: '-40px',
        opacity: 0,
    }, {
        y: '0px',
        opacity: 1,
        stagger: .1
    })
    .fromTo('.mobile-menu .btn-getIn', {
        y: '-40px',
        opacity: 0,
    }, {
        y: '0px',
        opacity: 1,
    }, '>.01')
let menuMobile = document.querySelector('.btn.btn-mobile-menu');
let menuMobileWrapper = document.querySelector('.mobile-menu');
let body = document.querySelector('body')
if (menuMobile) {
    menuMobile.addEventListener('click', function () {
        if (menuMobileWrapper) {
            if (menuMobileWrapper.classList.contains('mobile-menu__hidden')) {
                timelineHamburger.play();
                menuMobileWrapper.classList.remove('mobile-menu__hidden');
                menuMobileWrapper.classList.add('mobile-menu__show');
                menuMobile.classList.add('active')
                body.style.overflowY = 'hidden';
            } else {
                timelineHamburger.reverse();
                menuMobileWrapper.classList.remove('mobile-menu__show');
                menuMobileWrapper.classList.add('mobile-menu__hidden');
                menuMobile.classList.remove('active')
                body.style.overflowY = 'unset';
            }
        } else {
            menuMobileWrapper = document.querySelector('.mobile-menu');
        }
    })
}
// animate testimonial
const testimonialWrapper = document.querySelector('.testimonilas-wrapper');
if (testimonialWrapper) {
    const testimonialAnimate = gsap.timeline({
        defaults: {
            duration: 0.5
        },
        smoothChildTiming: true,
        scrollTrigger: {
            // markers: true,
            trigger: testimonialWrapper,
            start: "top 70%",
            end: "bottom center"
        }
    })
    testimonialAnimate
        .fromTo(
            '.testimonilas-wrapper .testimonial-slider .slick-list .testimonial-content', {
                scale: 1.2,
                opacity: 0
            }, {
                scale: 1,
                opacity: 1,
                duration: .8
            }
        )
        .fromTo(
            '.testimonilas-wrapper .testimonial-slider .slick-list .testimonial-item .testimonial-person', {
                scale: 1.2,
                opacity: 0
            }, {
                scale: 1,
                opacity: 1,
                duration: .7
            }
            , '<.1'
        )
        .fromTo(
            '.testimonilas-wrapper .testimonial-slider .slick-list .testimonial-item .testimonial-company', {
                scale: 1.2,
                opacity: 0
            }, {
                scale: 1,
                opacity: 1,
                duration: .7
            }
            , '.1'
        );;

        gsap.timeline({
            efaults: {
                duration: 0.5
            },
            smoothChildTiming: true,
            scrollTrigger: {
                // markers: true,
                trigger: testimonialWrapper,
                start: "top 70%",
                end: "bottom center"
            }
        })
        .fromTo(
            '.slick-prev', {
                scale: 1.2,
                opacity: 0
            }, {
                scale: 1,
                opacity: 1,
            },
            '<.1'
        )
        .fromTo(
            '.slick-next', {
                scale: 1.2,
                opacity: 0
            }, {
                scale: 1,
                opacity: 1,
            },
            '<.1'
        );
    const btnPrev = document.querySelector('.testimonial-slider button.slick-prev');
    if(btnPrev) {
    btnPrev.addEventListener('click', function () {
        document.querySelectorAll('.testimonial-item').forEach(element => {
            element.classList.add('slider-item-hidden');
        });
        setTimeout(function () {
            document.querySelectorAll('.testimonial-item').forEach(element => {
                element.classList.remove('slider-item-hidden');
            });
            testimonialAnimate.restart();
        }, 500);
    });
    }
    const btnNext = document.querySelector('.testimonial-slider button.slick-next');
    if(btnNext) {
    btnNext.addEventListener('click', function () {
        document.querySelectorAll('.testimonial-item').forEach(element => {
            element.classList.add('slider-item-hidden');
        });  
        setTimeout(function () {
            document.querySelectorAll('.testimonial-item').forEach(element => {
                element.classList.remove('slider-item-hidden');
            });
            testimonialAnimate.restart();
        }, 500);
    });
    }
    const slickDots = document.querySelectorAll('ul.slick-dots li button');
    if(slickDots){
    slickDots.forEach((slickItem, index) => {
        slickItem.addEventListener('click', function(){
            document.querySelectorAll('.testimonial-item').forEach(element => {
                element.classList.add('slider-item-hidden');
            });
            setTimeout(function () {
                document.querySelectorAll('.testimonial-item').forEach(element => {
                    element.classList.remove('slider-item-hidden');
                });
                testimonialAnimate.restart();
            }, 500);
        })
    });
}
}
// const ourServiceMenu = document.querySelector('#menu-item-1329');
// // ourServiceMenu.querySelector('a').href = '#';
// ourServiceMenu.classList.add('hidden');
// const portfolioMenu = document.querySelector('#menu-item-1327');
// // portfolioMenu.querySelector('a').href = '#';
// portfolioMenu.classList.add('hidden');
// const ourServiceMenuFooter = document.querySelector('#menu-item-180');
// // ourServiceMenuFooter.querySelector('a').href = '#';
// ourServiceMenuFooter.classList.add('hidden');
// const portfolioMenuFooter = document.querySelector('#menu-item-1325');
// // portfolioMenuFooter.querySelector('a').href = '#';
// portfolioMenuFooter.classList.add('hidden');
// const aboutMenu = document.querySelector('#menu-item-1330');
// aboutMenu.classList.add('hidden');
// const aboutMenuFooter = document.querySelector('#menu-item-179');
// aboutMenuFooter.classList.add('hidden');
const resourcesMenu = document.querySelector('#menu-item-1328');
resourcesMenu.classList.add('hidden');
const resourcesMenuFooter = document.querySelector('#menu-item-846');
resourcesMenuFooter.classList.add('hidden');
// const menuMobile2 = document.querySelector('.mobile-menu li.menu-item-1330');
// menuMobile2.classList.add('hidden');
// const menuMobile3 = document.querySelector('.mobile-menu li.menu-item-1329');
// menuMobile3.classList.add('hidden');
// const menuMobile4 = document.querySelector('.mobile-menu li.menu-item-1327');
// menuMobile4.classList.add('hidden');
const menuMobile5 = document.querySelector('.mobile-menu li.menu-item-1328');
menuMobile5.classList.add('hidden');
document.addEventListener('touchstart', function() {}, {passive: true});
document.addEventListener('DOMContentLoaded',function(){
    const siteEl = document.getElementById('site')
    if (siteEl) {
        if (siteEl.classList.contains('opacity-0')) {
            siteEl.classList.remove('opacity-0')
        }
        siteEl.classList.add('opacity-100');
    }
})
